<template>
  <div class="flex flex-col gap-4 pb-4 animate-pulse" data-testid="post-station-detail-skeleton">
    <!-- Card do médico (equiv. CardDutyWithDoctor): avatar + nome/CRM + dados do plantão -->
    <div class="flex flex-col gap-4 rounded-lg border border-slate-200 p-4">
      <div class="flex items-center gap-3">
        <div class="h-12 w-12 rounded-full bg-slate-200 shrink-0"></div>
        <div class="flex flex-col gap-1.5">
          <div class="h-4 w-32 bg-slate-200 rounded"></div>
          <div class="h-3 w-20 bg-slate-200 rounded"></div>
        </div>
      </div>

      <!-- Formação / equipe / posição / turno -->
      <div class="flex flex-wrap gap-2">
        <div v-for="tag in 4" :key="`tag-${tag}`" class="h-4 w-16 bg-slate-200 rounded"></div>
      </div>
    </div>

    <!-- Badge de status do domínio (equiv. LabelBadge) -->
    <div class="h-6 w-48 bg-slate-200 rounded-full"></div>

    <!-- Linhas Empresa / Unidade / Escala -->
    <div class="flex flex-col divide-y divide-gray-200">
      <div v-for="row in 3" :key="`info-${row}`" class="flex items-center justify-between py-3">
        <div class="h-3.5 w-20 bg-slate-200 rounded"></div>
        <div class="h-3.5 w-28 bg-slate-200 rounded"></div>
      </div>
    </div>

    <!-- Critérios avaliados -->
    <div class="flex flex-col gap-1">
      <div class="h-3 w-32 bg-slate-200 rounded mb-2"></div>

      <div
        v-for="criterion in 3"
        :key="`criterion-${criterion}`"
        class="flex items-center justify-between gap-4 py-3"
      >
        <div class="flex flex-col gap-1.5">
          <div class="h-3.5 w-40 bg-slate-200 rounded"></div>
          <div class="h-3 w-24 bg-slate-200 rounded"></div>
        </div>
        <div class="h-5 w-12 bg-slate-200 rounded-full shrink-0"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
